class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.overlay = document.getElementById('CartDrawerOverlay');
    this.content = document.getElementById('CartDrawerContent');
    this.total = document.getElementById('CartDrawerTotal');
    this.count = document.querySelectorAll('.cart-count');
    this.closeBtn = document.getElementById('CartDrawerClose');
    this.triggers = document.querySelectorAll('.js-open-cart');

    this.init();
  }

  init() {
    if (!this.drawer) return;

    // Open triggers
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close triggers
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());

    // Listen for add-to-cart events (optional, but good for Ajax integration)
    document.addEventListener('cart:updated', () => this.render());
    
    // Initial render
    this.render();
  }

  open() {
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Small delay to let the animation start before fetching if needed, 
    // but usually parallel is better.
    this.render();
  }

  close() {
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async render() {
    this.drawer.classList.add('is-loading');
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      this.updateCount(cart.item_count);
      
      if (cart.item_count === 0) {
        this.renderEmpty();
      } else {
        this.renderItems(cart);
      }
    } catch (error) {
      console.error('Cart Error:', error);
    } finally {
      this.drawer.classList.remove('is-loading');
    }
  }

  updateCount(count) {
    this.count.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  renderEmpty() {
    this.content.innerHTML = `
      <div class="cart-drawer__empty">
        <p>Votre panier est vide</p>
        <a href="/collections/all" class="btn btn-secondary">Continuer mes achats</a>
      </div>
    `;
    this.total.textContent = '0,00 €';
  }

  renderItems(cart) {
    let html = '';
    
    cart.items.forEach(item => {
      const price = (item.final_line_price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      
      html += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item__image">
            <img src="${item.image}" alt="${item.product_title}" width="80" height="80">
          </div>
          <div class="cart-item__details">
            <div>
              <h4 class="cart-item__title">${item.product_title}</h4>
              ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
              <p class="cart-item__price">${price}</p>
            </div>
            <div class="cart-item__actions">
              <div class="quantity-selector">
                <button onclick="cartDrawer.changeQuantity('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button onclick="cartDrawer.changeQuantity('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <span class="cart-item__remove" onclick="cartDrawer.changeQuantity('${item.key}', 0)">Supprimer</span>
            </div>
          </div>
        </div>
      `;
    });
    
    this.content.innerHTML = html;
    this.total.textContent = (cart.total_price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  async changeQuantity(key, quantity) {
    this.drawer.classList.add('is-loading');
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      
      const cart = await response.json();
      this.updateCount(cart.item_count);
      this.render();
      
    } catch (error) {
      console.error('Update Error:', error);
      this.drawer.classList.remove('is-loading');
    }
  }
}

// Global instance for onclick handlers
let cartDrawer;
document.addEventListener('DOMContentLoaded', () => {
  cartDrawer = new CartDrawer();
});
